import { buildPathString, buildQueryString } from "@zickko/shared";

export type BackLink = {
  backLink: string;
};

export type ContinueLink = {
  continueLink: string;
};

export type KeyValueMap = { [key: string]: string };

export type QueryParams = Partial<BackLink & ContinueLink>;

export const routeConfig = <P extends KeyValueMap, Q extends KeyValueMap>(template: string) => {
  const link = (pathParams: P, queryParams: Q) =>
    `${buildPathString(template, pathParams)}${buildQueryString(queryParams)}`;
  return {
    template,
    link,
  };
};
